import React from 'react';
import { Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import useWindowDimensions from 'hooks/useWindowDemensions';

interface MainLayoutProps {
  children?: React.ReactNode;
  onBack?: {
    onClick: () => void;
    show?: boolean;
  };
  mode?: 'scan';
  showHotline?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  children,
  onBack,
  mode,
  showHotline,
}) => {
  const { height } = useWindowDimensions();
  return (
    <main className="t-mainLayout" style={{ height: `${height}px`, maxHeight: `${height}px` }}>
      {onBack?.show && (
        <div className="t-mainLayout_back" onClick={onBack.onClick}>
          <Icon iconName="arrowDown" size="24" />
        </div>
      )}
      <div>
        {
          mode !== 'scan' ? (
            <div className="t-mainLayout_top">
              <Typography.Heading
                textStyle="center"
                fontweight="600"
                extendClasses="t-mainLayout_heading fs-48x68"
              >
                ĐĂNG KÍ THAM DỰ
                <br />
                HỘI THẢO DÀNH CHO
                <br />
                QUÝ NHÂN VIÊN Y TẾ
              </Typography.Heading>
            </div>
          ) : (
            <div className="t-mainLayout_top">
              <Typography.Heading
                textStyle="center"
                fontweight="600"
                extendClasses="t-mainLayout_heading fs-48x68"
              >
                HỆ THỐNG QUÉT MÃ
                <br />
                CHECK-IN
              </Typography.Heading>
            </div>
          )
        }
        <div className="t-mainLayout_content">{children}</div>
      </div>
      {
        showHotline && (
          <Typography.Text
            extendClasses="fs-18x26 t-mainLayout_hotline"
            textStyle="center"
          >
            Hotline hỗ trợ kỹ thuật vui lòng liên hệ
            {' '}
            <a href="tel:0919802059">091 980 2059</a>
          </Typography.Text>
        )
      }
    </main>
  );
};

export default MainLayout;
